﻿import React from "react";
import {
  CardContent,
  CardHeader,
  Typography,
  Box,
  Paper,
  Button,
} from "@mui/material";
import "./WorkflowManagerCard.css";
import { WorkFlowSummaryBorder } from "@/ImageRepo";
import { useTranslation } from "react-i18next";

const WorkflowManagerCard = ({
  name,
  sourceConnections,
  targetConnections,
  sourceArtifact,
  targetArtifact,
  errors,
  processing,
  notQueued,
  successful,
  total,
  operationId,
  receivingType,
}) => {
  const { t } = useTranslation("homepage");
  return (
    <Box className="workflow-card-and-border">
      <div className="workflowSummaryBorder">
        <img src={WorkFlowSummaryBorder} draggable="false" />
      </div>
      <Paper className="workflow-card">
        <CardContent className="workflow-card-content">
          <Box className="workflow-card-summary-info text-main">
            <Typography className="weight-semibold-text size-medium-text">
              {t(
                "workflow-summary.artifact-name." +
                  sourceArtifact.toLowerCase(),
                sourceArtifact.replace(/([a-z])([A-Z])/, "$1 $2")
              )}
            </Typography>
            <Typography className="weight-bold-text size-large-text">
              {total}
            </Typography>
            <Typography className="size-medium-text">
              {t(
                "workflow-summary." + receivingType.toLowerCase(),
                receivingType
              )}
            </Typography>
            <Box className="active-connections">
              <Box className="active-connections-icon size-icon-text">
                {sourceConnections}
              </Box>
              <Typography className="size-medium-small-text">
                {sourceConnections === 1
                  ? t("workflow-summary.active-connection", "Active Connection")
                  : t(
                      "workflow-summary.active-connections",
                      "Active Connections"
                    )}
              </Typography>
            </Box>
          </Box>
          <Box className="workflow-summary-bottom-half text-main">
            <Box className="artifact-title-box">
              <Typography className="weight-semibold-text size-medium-text">
                {t(
                  "workflow-summary.artifact-name." +
                    targetArtifact.toLowerCase(),
                  targetArtifact.replace(/([a-z])([A-Z])/, "$1 $2")
                )}
              </Typography>
            </Box>

            <Box className="workflow-card-details">
              <Box className="workflow-card-detail">
                <Box className="workflow-card-box successful"></Box>
                <Typography className="weight-semibold-text size-small-text padding-right-medium status-counter">
                  {successful}
                </Typography>
                <Typography className="weight-medium-text size-small-text">
                  {t("workflow-summary.successful", "Successful")}
                </Typography>
              </Box>
              <Box className="workflow-card-detail">
                <Box className="workflow-card-box processing"></Box>
                <Typography className="weight-semibold-text size-small-text padding-right-medium status-counter">
                  {processing}
                </Typography>
                <Typography className="weight-medium-text size-small-text">
                  {t("workflow-summary.processing", "Processing")}
                </Typography>
              </Box>
              <Box className="workflow-card-detail">
                <Box className="workflow-card-box error"></Box>
                <Typography className="weight-semibold-text size-small-text padding-right-medium status-counter">
                  {errors}
                </Typography>
                <Typography className="weight-medium-text size-small-text">
                  {t("workflow-summary.error", "Error")}
                </Typography>
              </Box>
              <Box className="workflow-card-detail">
                <Box className="workflow-card-box notqueued"></Box>
                <Typography className="weight-semibold-text size-small-text padding-right-medium status-counter">
                  {notQueued}
                </Typography>
                <Typography className="weight-medium-text size-small-text">
                  {t("workflow-summary.notqueued", "Not Queued")}
                </Typography>
              </Box>
            </Box>
            <Box className="workflow-card-summary-info">
              <Box className="active-connections">
                <Box className="active-connections-icon size-icon-text">
                  {targetConnections}
                </Box>
                <Typography className="size-smallest-text">
                  {targetConnections === 1
                    ? t(
                        "workflow-summary.active-connection",
                        "Active Connection"
                      )
                    : t(
                        "workflow-summary.active-connections",
                        "Active Connections"
                      )}
                </Typography>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Paper>
    </Box>
  );
};

export default WorkflowManagerCard;
